// extracted by mini-css-extract-plugin
module.exports = {"list":"social-icons-module--list--3UWd5","listItem":"social-icons-module--list-item--2_tEs","listItemLink":"social-icons-module--list-item-link--3K4R8"};